import { useCallback, useEffect, useRef, useState } from "react";
import { getMonitoringKpi, type MonitoringKpi } from "@/src/services/monitoring_service";

const EMPTY_KPI: MonitoringKpi = { total: 0, matched: 0, matchRate: 0, lastAlertAt: null };

export function useMonitoringKpi({
  infoResolved,
  reloadKey,
}: {
  infoResolved: boolean;
  reloadKey: number;
}) {
  const [kpi, setKpi] = useState<MonitoringKpi>(EMPTY_KPI);
  // Only until the first response — later refreshes keep showing the last values.
  const [loading, setLoading] = useState(true);
  const seqRef = useRef(0);
  const appliedSeqRef = useRef(0);

  // Live refreshes, reloads and the "finished" refresh can overlap — never let
  // an older response overwrite a newer one.
  const refresh = useCallback(() => {
    const seq = ++seqRef.current;
    getMonitoringKpi().then((res) => {
      setLoading(false);
      if (!res.ok || seq <= appliedSeqRef.current) return;
      appliedSeqRef.current = seq;
      setKpi(res.value);
    });
  }, []);

  useEffect(() => {
    if (!infoResolved) return;
    refresh();
  }, [infoResolved, reloadKey, refresh]);

  return { kpi, loading, refresh };
}
